import type { Usuario } from './tipos';

/**
 * Uma pessoa pode ser admin, contador de um escritório e cliente de uma
 * empresa ao mesmo tempo (ver sessao.js no backend) -- mas ela só quer
 * usar um chapéu por vez, senão o menu vira uma mistura de telas de
 * administração com telas de contador. É o que esta tela resolve,
 * nos moldes do soupsy: escolher em qual conta entrar.
 */
export interface OpcaoContexto {
  tipo: 'admin' | 'escritorio' | 'empresa' | 'softhouse';
  id?: number;
  rotulo: string;
  detalhe: string;
}

export function contextosDe(usuario: Usuario): OpcaoContexto[] {
  const out: OpcaoContexto[] = [];
  if (usuario.perfis.includes('admin')) {
    out.push({ tipo: 'admin', rotulo: 'Administrador', detalhe: 'Gerenciar o Conti9 inteiro' });
  }
  for (const e of usuario.escritorios) {
    out.push({ tipo: 'escritorio', id: e.id, rotulo: e.nome, detalhe: 'Contador' });
  }
  for (const e of usuario.empresas) {
    out.push({ tipo: 'empresa', id: e.id, rotulo: e.razaoSocial, detalhe: 'Cliente' });
  }
  if (usuario.perfis.includes('softhouse')) {
    out.push({ tipo: 'softhouse', rotulo: 'Suporte', detalhe: 'Atender chamados, só com prazo' });
  }
  return out;
}

/** O valor que vai no cabeçalho X-Conti9-Contexto. */
export function chaveContexto(o: OpcaoContexto): string {
  return o.tipo === 'admin' || o.tipo === 'softhouse' ? o.tipo : `${o.tipo}:${o.id}`;
}
